import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Space, Tag, message, Badge } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeOutlined, LogoutOutlined, UserOutlined, FileTextOutlined, RestOutlined, AuditOutlined } from '@ant-design/icons';
import api from '../utils/api';
import ThemeColorPicker from './ThemeColorPicker';
import { useTheme } from '../context/ThemeContext';

const { Header } = Layout;

const AppHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const [pendingApprovalCount, setPendingApprovalCount] = useState(0);
  const { isDarkMode, getBackgroundColor } = useTheme();

  const roleMap = {
    designer: '设计师',
    designer_leader: '设计师领导',
    sales: '销售',
    admin: '管理员'
  };

  // 判断是否有审批权限：designer_leader、admin 或被授权的领导（isLeader）
  const hasApprovalAccess = user.role === 'admin' || user.role === 'designer_leader' || user.isLeader === true;

  useEffect(() => {
    const fetchCounts = async () => {
      if (hasApprovalAccess) {
        try {
          const res = await api.get('/drawing-approvals/pending-count');
          setPendingApprovalCount(res.data.count || 0);
        } catch (e) {}
      }
    };
    
    fetchCounts();
    
    const handleRefresh = () => fetchCounts();
    window.addEventListener('refresh-pending-count', handleRefresh);
    
    return () => {
      window.removeEventListener('refresh-pending-count', handleRefresh);
    };
  }, [hasApprovalAccess, location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    message.success('已退出登录');
    navigate('/login');
  };

  const items = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: '首页',
      onClick: () => navigate('/')
    }
  ];

  // 有审批权限的用户显示图纸审批菜单（包括被授权者）
  if (hasApprovalAccess) {
    items.push({
      key: '/drawing-approvals',
      icon: (
        <Badge dot={pendingApprovalCount > 0} offset={[5, -2]}>
          <AuditOutlined />
        </Badge>
      ),
      label: '图纸审批',
      onClick: () => navigate('/drawing-approvals')
    });
  }

  if (user.role === 'admin') {
    items.push({
      key: '/recycle-bin',
      icon: <RestOutlined />,
      label: '回收站',
      onClick: () => navigate('/recycle-bin')
    });
    items.push({
      key: '/system-logs',
      icon: <FileTextOutlined />,
      label: '系统日志',
      onClick: () => navigate('/system-logs')
    });
  }

  return (
    <Header style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      background: '#001529',
      borderBottom: 'none',
      boxShadow: 'none',
      lineHeight: '64px',
      padding: '0 24px'
    }}>
      <div style={{ color: '#fff', fontSize: 18, fontWeight: 'bold' }}>
        图纸库管理系统
      </div>
      <Menu
        theme="dark"
        mode="horizontal"
        selectedKeys={[location.pathname]}
        items={items}
        style={{ 
          flex: 1, 
          marginLeft: 30, 
          minWidth: 0,
          background: 'transparent',
          borderBottom: 'none'
        }}
      />
      <Space>
        <ThemeColorPicker />
        <Tag color="blue"><UserOutlined /> {user.name || user.username}（{roleMap[user.role] || user.role}）</Tag>
        <Button type="primary" danger icon={<LogoutOutlined />} onClick={handleLogout}>
          退出
        </Button>
      </Space>
    </Header>
  );
};

export default AppHeader;